import React, { useEffect, useState } from 'react';
const trackFbEvent = (event: string, data?: Record<string, any>) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', event, data);
  }
};
type Plan = 'megapack' | 'megapack-pro' | 'megapack-premium';
export function Pricing() {
  const [selected, setSelected] = useState<Plan>('megapack-premium');
  useEffect(() => {
    const section = document.getElementById('pricing');
    if (!section) return;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        trackFbEvent('ViewContent', {
          content_name: 'Pricing Section',
          content_category: 'Médico en Proceso'
        });
        observer.disconnect();
      }
    }, {
      threshold: 0.3
    });
    observer.observe(section);
    return () => observer.disconnect();
  }, []);
  const cartUrls: Record<Plan, string> = {
    megapack: 'https://www.bibliotecaprofesional.com/cart/48331899568298:1',
    'megapack-pro': 'https://www.bibliotecaprofesional.com/cart/48331900715178:1',
    'megapack-premium': 'https://www.bibliotecaprofesional.com/cart/48331901698218:1'
  };
  const plans: Record<Plan, {
    emoji: string;
    name: string;
    desc: string;
    priceOld: string;
    priceNew: string;
    cta: string;
    sub: string;
    badge?: string;
    highlight?: boolean;
  }> = {
    megapack: {
      emoji: '✅',
      name: 'MÉDICO EN PROCESO™ — NIVEL 1',
      desc: '6 tomos + 6 bonos · Toda la carrera organizada',
      priceOld: '$58.990',
      priceNew: '$19.990',
      cta: '→ SÍ, QUIERO EL NIVEL 1',
      sub: '6 tomos · 6 bonos · Acceso inmediato'
    },
    'megapack-pro': {
      emoji: '⭐',
      name: 'SISTEMA CARRERA ORGANIZADA™ — NIVEL 2',
      desc: 'Todo el Nivel 1 + Tomo Guardia + Tomo Medicina Interna',
      priceOld: '$102.990',
      priceNew: '$27.990',
      cta: '→ SÍ, QUIERO EL NIVEL 2',
      sub: '8 tomos · 6 bonos · Clínica completa · Acceso inmediato',
      badge: '⭐ MÁS ELEGIDO'
    },
    'megapack-premium': {
      emoji: '🏆',
      name: 'SISTEMA DE GESTIÓN ACADÉMICA™ — NIVEL 3',
      desc: 'Todo el Nivel 2 + 7 editables premium para dominar la carrera',
      priceOld: '$149.990',
      priceNew: '$32.990',
      cta: '→ SÍ, QUIERO EL NIVEL 3 COMPLETO',
      sub: '8 tomos · 6 bonos · 7 editables · Acceso inmediato',
      badge: '🏆 MÁS COMPLETO',
      highlight: true
    }
  };
  const active = plans[selected];
  return <section id="pricing" className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 relative" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(240,249,255) 0%, rgb(224,242,254) 50%, rgb(186,230,253) 100%)'
  }} data-id="element-231">
      <div className="mx-auto max-w-3xl" data-id="element-232">
        {/* Heading */}
        <div className="text-center mb-7" data-id="element-233">
          <div className="inline-flex items-center gap-2 text-[11px] font-bold tracking-wide rounded-full px-4 py-1.5 mb-3" style={{
          color: '#0284c7',
          border: '1px solid rgba(2,132,199,0.4)',
          backgroundColor: 'rgba(2,132,199,0.05)'
        }} data-id="element-234">
            🔥 Precio de lanzamiento — Sube sin previo aviso
          </div>
          <h2 className="text-3xl sm:text-4xl font-black text-gray-900 m-0 mb-2" data-id="element-235">
            Toda la carrera ordenada.{' '}
            <span style={{
            background: 'linear-gradient(90deg, #0369a1, #0ea5e9)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }} data-id="element-236">
              Dejá de improvisar y avanzá de una vez.
            </span>
          </h2>
          <p className="text-sm text-gray-500 m-0" data-id="element-237">
            Las tres opciones incluyen los 6 bonos completos · Acceso inmediato
          </p>
        </div>

        {/* Plan Selector */}
        <div className="flex flex-col gap-3 mb-6" data-id="element-238">
          {(Object.keys(plans) as Plan[]).map(plan => {
          const p = plans[plan];
          const isSelected = selected === plan;
          const isPremium = plan === 'megapack-premium';
          return <button key={plan} onClick={() => setSelected(plan)} className="w-full text-left rounded-2xl transition-all cursor-pointer" style={{
            background: isPremium ? 'linear-gradient(135deg, #0369a1, #0ea5e9)' : 'transparent',
            boxShadow: isSelected ? isPremium ? 'rgba(2,132,199,0.4) 0px 8px 30px 0px' : 'rgba(14,165,233,0.2) 0px 4px 20px 0px' : 'none'
          }} data-id="element-239">
                <div className="rounded-2xl overflow-hidden" style={{
              padding: isPremium ? '2px' : '0',
              background: isPremium ? 'linear-gradient(135deg, #0369a1, #7dd3fc)' : 'transparent'
            }} data-id="element-240">
                  <div className="rounded-2xl p-4" style={{
                backgroundColor: isSelected ? 'rgb(240,249,255)' : 'rgb(255,255,255)',
                border: !isPremium ? isSelected ? '2px solid #0284c7' : '1px solid rgb(229,231,235)' : 'none'
              }} data-id="element-241">
                    {/* Badge */}
                    {p.badge && <div className="mb-2" data-id="element-242">
                        <span className="text-[10px] font-black px-2.5 py-1 rounded-full" style={{
                    backgroundColor: isPremium ? '#0284c7' : 'rgb(224,242,254)',
                    color: isPremium ? 'white' : '#0284c7'
                  }} data-id="element-243">
                          {p.badge}
                        </span>
                      </div>}

                    <div className="flex items-center gap-3" data-id="element-244">
                      {/* Radio */}
                      <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 transition-all" style={{
                    borderColor: isSelected ? '#0284c7' : 'rgb(209,213,219)'
                  }} data-id="element-245">
                        {isSelected && <div className="h-2.5 w-2.5 rounded-full" style={{
                      backgroundColor: '#0284c7'
                    }} data-id="element-246" />}
                      </div>

                      {/* Info */}
                      <div className="flex-1 min-w-0" data-id="element-247">
                        <div className="flex flex-wrap items-center gap-1.5 mb-0.5" data-id="element-248">
                          <span className="text-base" data-id="element-249">{p.emoji}</span>
                          <span className="text-sm font-black" style={{
                        color: isPremium && isSelected ? '#0284c7' : 'rgb(17,24,39)'
                      }} data-id="element-250">
                            {p.name}
                          </span>
                        </div>
                        <p className="text-xs text-gray-500 m-0" data-id="element-251">{p.desc}</p>
                      </div>

                      {/* Price */}
                      <div className="shrink-0 text-right" data-id="element-252">
                        <div className="text-xs text-gray-400 line-through" data-id="element-253">
                          {p.priceOld}
                        </div>
                        <div className="text-2xl font-black" style={{
                      color: isPremium ? '#0284c7' : isSelected ? '#0284c7' : 'rgb(17,24,39)'
                    }} data-id="element-254">
                          {p.priceNew}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* CTA Block */}
        <div className="rounded-2xl p-5 shadow-xl" style={{
        background: 'linear-gradient(135deg, #0369a1 0%, #0284c7 60%, #0ea5e9 100%)',
        boxShadow: 'rgba(2,132,199,0.35) 0px 10px 40px 0px'
      }} data-id="element-255">
          {/* What's included */}
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1.5 mb-4" data-id="element-256">
            {active.sub.split(' · ').map(item => <span key={item} className="text-[11px] font-bold text-white flex items-center gap-1" data-id="element-257">
                <span className="inline-flex items-center justify-center w-3.5 h-3.5 rounded-full text-[9px] font-black" style={{
              backgroundColor: 'rgba(255,255,255,0.25)'
            }} data-id="element-258">
                  ✓
                </span>{' '}
                {item}
              </span>)}
          </div>

          {/* Button */}
          <a href={cartUrls[selected]} onClick={() => trackFbEvent('InitiateCheckout', {
          content_name: active.name,
          content_category: 'Médico en Proceso',
          value: selected === 'megapack-premium' ? 32990 : selected === 'megapack-pro' ? 27990 : 19990,
          currency: 'ARS'
        })} className="block w-full text-center text-sm sm:text-base font-black rounded-xl py-4 no-underline transition-all" style={{
          backgroundColor: 'rgb(255,255,255)',
          color: '#0284c7',
          boxShadow: 'rgba(0,0,0,0.15) 0px 4px 15px 0px'
        }} onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = 'rgb(240,249,255)';
        }} onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = 'rgb(255,255,255)';
        }} data-id="element-259">
            {active.cta}
          </a>

          <p className="text-center text-[11px] text-white/70 mt-3 mb-0" data-id="element-260">
            +1.800 estudiantes ya tienen toda la carrera de Medicina organizada
            en un solo lugar
          </p>
        </div>

        {/* Trust Badges */}
        <div className="mt-4 flex flex-wrap items-center justify-center gap-3 text-xs text-gray-600 rounded-2xl px-4 py-3 shadow-sm" style={{
        backgroundColor: 'rgb(255,255,255)',
        border: '1px solid rgba(14,165,233,0.25)'
      }} data-id="element-261">
          <span className="flex items-center gap-1 font-medium" data-id="element-262">
            🔒 Pago seguro
          </span>
          <span className="text-gray-300" data-id="element-263">|</span>
          <span className="flex items-center gap-1 font-medium" data-id="element-264">
            ⚡ Acceso en 5 min
          </span>
          <span className="text-gray-300" data-id="element-265">|</span>
          <span className="flex items-center gap-1 font-medium" data-id="element-266">
            🛡️ Garantía 7 días
          </span>
          <span className="text-gray-300" data-id="element-267">|</span>
          <span className="flex items-center gap-1 font-medium" data-id="element-268">
            💳 Mercado Pago
          </span>
        </div>
      </div>

      {/* Degradé de integración con ProBusiness */}
      <div className="absolute bottom-0 left-0 right-0 h-16 pointer-events-none" style={{
      background: 'linear-gradient(to bottom, transparent 0%, rgb(248,251,255) 100%)'
    }} data-id="element-269" />
    </section>;
}